import React, { useContext, useEffect, useRef } from "react"

import { connect } from "react-redux"

import {
  getContactsConnectors,
  connectDefaultGoogleContacts,
} from "@actions/contactActions"
import { NewModal } from "@components"
import { ButtonEl } from "@components/common"
import { loginProviders } from "@config/enums"
import { BUTTON_VARIANTS } from "@constants/button"
import {
  SyncContactsContext,
  SYNC_CONTACTS_MODAL,
} from "@contexts/SyncContactsContext"

import { ConnectorItem } from "./ConnectorItem"
import { LinkedInUploadRow } from "./LinkedInUpload"
import { ModalsBody } from "./ModalsBody"
import { ContactsWrapper } from "./contactsStyles"

const Contacts = ({ contactsConnectors, identities, onLinkedInUploaded }) => {
  // FIX 1 (contacts-default): only ever attempt the automatic default-connect once per mount --
  // the connectors fetch + default-connect both dispatch into `contactsConnectors`, which is a
  // dependency of this effect, so without this guard a settled empty-fetch/failed-default cycle
  // could re-trigger the POST on every re-render.
  const hasAttemptedDefaultRef = useRef(false)

  useEffect(() => {
    if (contactsConnectors.length > 0) return

    getContactsConnectors().then(connectors => {
      if (connectors && connectors.length > 0) return
      if (hasAttemptedDefaultRef.current) return

      const hasGoogleIdentity = (identities || []).some(
        identity => identity?.provider === loginProviders.google
      )

      if (!hasGoogleIdentity) return

      hasAttemptedDefaultRef.current = true
      connectDefaultGoogleContacts()
    })
  }, [contactsConnectors, identities])

  const { contactsModalData, setModalType } = useContext(SyncContactsContext)

  return (
    <ContactsWrapper>
      {contactsConnectors.length > 0 ? (
        contactsConnectors.map((connector, connectorIndex) => (
          <ConnectorItem
            connector={connector}
            isFirst={connectorIndex === 0}
            isLast={contactsConnectors.length - 1 === connectorIndex}
            key={connector.id}
          />
        ))
      ) : (
        <ConnectorItem
          connectProvider={loginProviders.google}
          isFirst={true}
          isLast={true}
        />
      )}

      <LinkedInUploadRow onUploaded={onLinkedInUploaded} />

      <ButtonEl
        variant={BUTTON_VARIANTS.BORDERED}
        text="Add another"
        onClick={() => setModalType(SYNC_CONTACTS_MODAL.ADD_ANOTHER)}
      />

      <NewModal {...contactsModalData}>
        <ModalsBody />
      </NewModal>
    </ContactsWrapper>
  )
}

const mapStateToProps = ({ contacts, user }) => ({
  contactsConnectors: contacts.syncConnectors,
  identities: user?.userInfo?.identities,
})

export default connect(mapStateToProps)(Contacts)
